export const vendor = "gomyfooddelivery3@gmail.com"
export const defaultProduct = "https://res.cloudinary.com/own4/image/upload/v1685796677/default-product/u8m926iqoiyvaxoonzvu.png"
export const STRIPE_PUBLIC_KEY = "pk_test_51HESORBqdLOQQSIFYonpevBtbnRhovvoNY4ZjCef2d2LQ4JkfLRf7QzMfu1Y9iwmhkywqWuQGbQlPrUFz82uUT7S00MTWyrtYM"

